'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = ['M16 384l0 80 480 0 0-80c0-44.2-35.8-80-80-80-2.5 0-4.9 .1-7.3 .3l-8.7 .8 0-33.1c0-35.3-28.7-64-64-64-23.7 0-44.4 12.9-55.5 32l-8.5 14.8-5.9-16c-13.5-36.7-48.8-62.8-90.1-62.8-53 0-96 43-96 96l0 33.4-5.8 1.6C40.6 316.5 16 347.4 16 384zM281.9 152.1c1 .9 1.9 1.7 2.9 2.6 15.7-6.9 33-10.7 51.2-10.7 24.8 0 48 7.1 67.7 19.3 40.8-32.1 92.3-51.3 148.3-51.3l24 0c0-32 0-64 0-96l-24 0C441.3 16 343.1 69.5 281.9 152.1zm135.3 21c22.5 18.5 38.6 44.6 44.4 74.3 3.7 1.2 7.4 2.6 11 4.2 21.8-17.3 49.4-27.6 79.4-27.6l24 0c0-32 0-64 0-96l-24 0c-50.5 0-97.1 16.7-134.8 45.1z', 'M281.9 152.1C343.1 69.5 441.3 16 552 16l24 0 0-16-24 0c-115.7 0-218.4 55.9-282.6 142.1 4.3 3.1 8.5 6.5 12.5 10zM488.6 259.6c18-12.4 39.8-19.6 63.4-19.6l24 0 0-16-24 0c-30 0-57.5 10.3-79.4 27.6 5.5 2.4 10.9 5.1 16 8.1zm-71.4-86.6C454.7 144.8 501.4 128 552 128l24 0 0-16-24 0c-56 0-107.5 19.2-148.3 51.3 4.7 3 9.3 6.2 13.6 9.7zM176 160c-61.9 0-112 50.1-112 112l0 21.5C26.7 306.6 0 342.2 0 384l0 96 512 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28-18.7-35.7-56.1-60-99.2-60zM80 272c0-53 43-96 96-96 41.3 0 76.6 26.1 90.1 62.8l5.9 16 8.5-14.8c11.1-19.2 31.8-32 55.5-32 35.3 0 64 28.7 64 64l0 33.1 8.7-.8c2.4-.2 4.8-.3 7.3-.3 44.2 0 80 35.8 80 80l0 80-480 0 0-80c0-36.6 24.6-67.5 58.2-77l5.8-1.6 0-33.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;